(function () {
  var pod = document.querySelector('.pod-personalization');
  if (!pod) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function human(b) { return b < 1024 ? b + ' B' : b < 1048576 ? (b / 1024).toFixed(0) + ' KB' : (b / 1048576).toFixed(1) + ' MB'; }

  pod.querySelectorAll('[data-pod-uploader]').forEach(function (up) {
    var fileInput = up.querySelector('[data-pod-file]');
    var drop = up.querySelector('[data-pod-drop]');
    var prog = up.querySelector('[data-pod-prog]');
    var bar = up.querySelector('[data-pod-bar]'), barFill = bar.querySelector('i');
    var pct = up.querySelector('[data-pod-pct]');
    var pName = up.querySelector('[data-pod-prog-name]');
    var done = up.querySelector('[data-pod-done]'), dName = up.querySelector('[data-pod-done-name]');
    var thumbs = up.querySelector('[data-pod-thumbs]');
    var errEl = up.querySelector('[data-pod-err]'), changeBtn = up.querySelector('[data-pod-change]'), urlInput = up.querySelector('[data-pod-url]');
    var inputsSpan = up.querySelector('[data-pod-inputs]');
    var key = up.getAttribute('data-pod-key');
    var label = up.getAttribute('data-pod-label');

    var uploadedUrls = [];

    function showErr(m) { errEl.textContent = m; errEl.classList.add('pod-show'); }
    function reset() {
      uploadedUrls = [];
      urlInput.value = '';
      if (inputsSpan) inputsSpan.innerHTML = '';
      fileInput.value = '';
      if (thumbs) thumbs.innerHTML = '';
      done.classList.remove('pod-show');
      prog.classList.remove('pod-show');
      errEl.classList.remove('pod-show');
      drop.style.display = '';
    }

    ['dragenter', 'dragover'].forEach(function (e) { drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.add('pod-dragging'); }); });
    ['dragleave', 'drop'].forEach(function (e) { drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.remove('pod-dragging'); }); });
    drop.addEventListener('drop', function (ev) {
      var files = ev.dataTransfer.files;
      for (var i = 0; i < files.length; i++) handle(files[i], i, files.length);
    });
    fileInput.addEventListener('change', function () {
      var files = fileInput.files;
      for (var i = 0; i < files.length; i++) handle(files[i], i, files.length);
    });
    changeBtn.addEventListener('click', function (e) { e.preventDefault(); reset(); });

    function handle(file, idx, total) {
      errEl.classList.remove('pod-show');
      if (!/^image\//.test(file.type)) { showErr('Please choose an image file.'); return; }
      if (file.size > 20 * 1024 * 1024) { showErr('Image too large (max 20 MB).'); return; }
      var preview = URL.createObjectURL(file);
      if (pName) pName.textContent = file.name;
      pct.textContent = '0%'; barFill.style.width = '0%'; bar.classList.remove('pod-indeterminate');
      drop.style.display = 'none'; done.classList.remove('pod-show'); prog.classList.add('pod-show');

      var form = urlInput.form;
      var idEl = form ? form.querySelector('[name="id"]') : null;
      var variantId = idEl ? idEl.value : null;
      if (!variantId) { showErr('Cannot detect product variant.'); prog.classList.remove('pod-show'); drop.style.display = ''; return; }

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', 1);
      fd.append('properties[__pod_tmp_upload]', file);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', ROOT + 'cart/add.js');
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable) {
          var p = Math.round(e.loaded / e.total * 100);
          barFill.style.width = p + '%'; pct.textContent = p + '%';
          if (p >= 100) { bar.classList.add('pod-indeterminate'); pct.textContent = 'Processing…'; }
        }
      };
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var res = JSON.parse(xhr.responseText);
            var item = res.items ? res.items[0] : res;
            var url = item.properties['__pod_tmp_upload'];
            var cartKey = item.key;
            fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: cartKey, quantity: 0 }) });
            uploadedUrls.push(url);
            urlInput.value = uploadedUrls.join(',');
            if (inputsSpan) {
              uploadedUrls.forEach(function (u, i) {
                var existing = inputsSpan.querySelector('[data-pod-idx="' + i + '"]');
                if (!existing) {
                  var inp = document.createElement('input');
                  inp.type = 'hidden';
                  var keyPrefix = key.replace(/\d+$/, '');
                  var keyStart = parseInt(key.replace(/\D/g, ''), 10) || 1;
                  inp.name = 'properties[' + keyPrefix + (keyStart + i) + ': ' + label + ']';
                  inp.value = u;
                  inp.setAttribute('form', form.getAttribute('id'));
                  inp.setAttribute('data-pod-idx', i);
                  inputsSpan.appendChild(inp);
                }
              });
            }
            if (thumbs) {
              var img = document.createElement('img');
              img.src = preview;
              img.alt = file.name;
              thumbs.appendChild(img);
            }
            prog.classList.remove('pod-show');
            if (dName) dName.textContent = uploadedUrls.length + ' photo(s) uploaded';
            done.classList.add('pod-show');
          } catch (e2) { showErr('Upload failed. Try again.'); prog.classList.remove('pod-show'); drop.style.display = ''; }
        } else { showErr('Upload failed (' + xhr.status + '). Try again.'); prog.classList.remove('pod-show'); drop.style.display = ''; }
      };
      xhr.onerror = function () { showErr('Network error. Try again.'); prog.classList.remove('pod-show'); drop.style.display = ''; };
      xhr.send(fd);
    }
  });
})();

